import React, { Component } from 'react';
import SelectionPopover from 'react-selection-popover';
import Slider from 'react-slick';
import { Button } from 'reactstrap';

import 'sweetalert2/dist/sweetalert2.css';
import language from '../../../../assets/languages/language';
import { questionsettings } from '../../../../common/cbtleftnavigationsettings';
import { SecondsToHHMMSS, filterObj, optionsArr } from '../../../../common/constant';
import { clearSelection, highlightString } from '../../../../common/highlightText';
import Loader from '../../../../common/loader';
import { showSuccess } from '../../../../common/toast';
import CBTFinishTest from '../../../Common/CBTFinishTest';
import CBTFlagged from '../../../Common/CBTFlagged';
import CBTNonAttempted from '../../../Common/CBTNonAttempted';
import FD from '../../../RestAPI/fetchData';
import AppRoutes from '../../../config/AppRoutes';
import App_data from '../../../config/App_data';
import { renderHTMLContent } from '../../../../common/function';
import { nextAwareRoute } from '../../../../common/cfa1NextRoutes';

/* eslint-disable*/
const longPressDuration = 450;
class CFAQuestions extends Component {
  selectionShare;
  constructor(props) {
    super(props);
    this.state = {
      questionsData: [],
      isLoading: true,
      isDataLoading: true,
      token: '',
      idname: '',
      userStatsData: '',
      time: {},
      seconds: this.props.params.timer ? parseInt(this.props.params.timer) : 0,
      showFinishTestPopup: false,
      mockName: '',
      flag: [],
      showSectionReview: false,
      showAttempted: false,
      showUnattempted: false,
      showFlagged: false,
      filter: [],
      showNonAttemptedPopup: false,
      showFlaggedPopup: false,
      selectedQuestionData: [],
      runDecrement: true,
      isNegative: false,
      timerStart: this.props.params.timerStart,
      selectedQuestion: '',
      highlights: [],
      showPopover: false,
      strikeThroughArr: [],
    };
    this.longPressCountdown = null;
    this.timer = 0;
    this.countDown = this.countDown.bind(this);
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  componentDidUpdate = prevProps => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (prevProps.params.offset !== this.props.params.offset) {
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      };
      this.getQuestions(data);
    }
  };

  componentDidMount = async () => {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
    };
    this.getQuestions(data);
    this.getUserStats();
    this.getFlagQuestions();
    if (this.props.params.timerStart === 'true') {
      this.timer = setInterval(this.countDown, 1000);
    } else {
      clearInterval(this.timer);
    }
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getMockNamebyId', data).then(async res => {
      this.setState({
        mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
      });
    });
  };

  getQuestions = data => {
    this.setState({
      isDataLoading: true,
      highlights: [],
    });
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let highlightdata = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getCFAMockQuestions', data).then(resp => {
      if (resp.success) {
        this.getHighlightedText(highlightdata);
        this.getStrikedText(highlightdata);
        this.setState({
          questionsData: resp.question,
          selectedQuestionData: resp.question[this.props.params.offset],
          isLoading: false,
          isDataLoading: false,
          selectedQuestion: resp.question[this.props.params.offset].question,
        });
      } else {
        this.setState({
          isLoading: false,
          isDataLoading: false,
        });
      }
    });
  };

  getUserStats = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getUsersStats', data).then(resp => {
      if (resp.success) {
        this.setState({
          userStatsData: resp.data,
          seconds: resp.data.user_time_value
            ? resp.data.user_time_value
            : parseInt(this.props.params.timer),
          isNegative: resp.data.isNegative,
        });
      } else {
        this.setState({
          isLoading: false,
        });
      }
    });
  };

  changeQuestion = (questionNumber, index) => {
    this.slider.slickGoTo(index - 1);
    this.getUserStats();
    this.getFlagQuestions();
    if (questionNumber) {
      this.context.router.push({
        pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTIONS)
          .replace(':id', this.props.params.id)
          .replace(':questiono', questionNumber)
          .replace(':timer', this.props.params.timer)
          .replace(':testid', this.props.params.testid)
          .replace(':offset', index)
          .replace(':isNegative', this.props.params.isNegative)
          .replace(':timerStart', this.props.params.timerStart),
      });
    }
  };

  getPrevious = index => {
    this.slider.slickGoTo(index - 2);
    const { questionsData } = this.state;
    this.getUserStats();
    this.getFlagQuestions();
    this.context.router.push({
      pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTIONS)
        .replace(':id', this.props.params.id)
        .replace(
          ':questiono',
          this.props.params.offset ? questionsData[parseInt(this.props.params.offset) - 1].id : 1,
        )
        .replace(':timer', this.props.params.timer)
        .replace(':testid', this.props.params.testid)
        .replace(
          ':offset',
          this.props.params.offset ? parseInt(this.props.params.offset) - 1 : 1,
        )
        .replace(':isNegative', this.props.params.isNegative)
        .replace(':timerStart', this.props.params.timerStart),
    });
  };

  addHighlight = async text => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const { selectedQuestionData } = this.state;

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: selectedQuestionData.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      type: 'highlight',
      text: text,
    };
    await FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/addHighlightedText', data).then(
      async res => {
        this.setState({ showPopover: false });
        await this.getHighlightedText();
        clearSelection();
      },
    );
  };

  deleteHighlight = async id => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));

    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: id,
    };

    if (id) {
      await FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/deleteHighlightedText', data).then(
        async res => {
          this.setState({ showPopover: false });
          await this.getHighlightedText();
          clearSelection();
        },
      );
    } else {
      return;
    }
  };

  getHighlightedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getHighlightedText', data).then(
      async res => {
        this.setState({
          highlights: res.questions,
        });
      },
    );
  };

  getNext = index => {
    const { questionsData } = this.state;
    this.getFlagQuestions();
    this.getUserStats();
    this.slider.slickGoTo(index);
    this.context.router.push({
      pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTIONS)
        .replace(':id', this.props.params.id)
        .replace(
          ':questiono',
          this.props.params.offset ? questionsData[parseInt(this.props.params.offset) + 1].id : 1,
        )
        .replace(':timer', this.props.params.timer)
        .replace(':testid', this.props.params.testid)
        .replace(
          ':offset',
          this.props.params.offset ? parseInt(this.props.params.offset) + 1 : 1,
        )
        .replace(':isNegative', this.props.params.isNegative)
        .replace(':timerStart', this.props.params.timerStart),
    });
  };

  getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    //console.log('userAgent', userAgent);
    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
      return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return 'iOS';
    }

    return 'unknown';
  };

  clickOption = async (choice, questionId, selectedQuestionData, e) => {
    //console.log('e. type ___________', e.type);
    e.preventDefault();
    // on left click
    if (e.type === 'click') {
      //console.log('Left click');
      const userData = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
        choice: choice,
        questionId: questionId,
        id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
        offset: this.props.params.offset ? parseInt(this.props.params.offset) : null,
      };
      this.updateSelectedChoice(userData, selectedQuestionData, choice);
    } else if (e.type === 'contextmenu') {
      //console.log('Right click');
      //on right click
      this.addStrikeThrough(choice);
    }
  };

  addStrikeThrough = async choice => {
    //console.log('inside call apiiiii', choice);
    const { selectedQuestionData } = this.state;
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: selectedQuestionData.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      choice: choice,
    };

    await FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/addStrikeThrough', data).then(
      async res => {
        //console.log('resssssssssssssssss', res);
        // this.setState({ showPopover: false });
        await this.getStrikedText();
        // clearSelection();
      },
    );
    // };
  };

  updateSelectedChoice = (userData, selectedQuestionData, choice) => {
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/updateUsersChoice', userData).then(
      async res => {
        if (res.success) {
          const ansData = {
            token: this.state.token,
            idname: this.state.idname,
            mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
            question_id: selectedQuestionData.id,
            answer:
              selectedQuestionData && selectedQuestionData.answer === choice
                ? 'correct'
                : 'incorrect',
            test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
            reading_id: selectedQuestionData.chapter_id,
          };
          this.getUserStats();
          FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/updateUserAnswer', ansData).then(
            async res => { },
          );
        }
      },
    );
  };

  countDown() {
    const { runDecrement } = this.state;
    let seconds;
    if (this.state.seconds != 0 && runDecrement && this.props.params.isNegative === 'true') {
      seconds = this.state.seconds - 1;
    } else {
      seconds = this.state.seconds + 1;
      this.context.router.push({
        pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTIONS)
          .replace(':id', this.props.params.id)
          .replace(':questiono', this.props.params.questiono)
          .replace(':timer', this.props.params.timer)
          .replace(':testid', this.props.params.testid)
          .replace(':offset', this.props.params.offset)
          .replace(':isNegative', 'false')
          .replace(':timerStart', this.props.params.timerStart),
      });
      this.setState({
        runDecrement: false,
      });
    }
    this.setState({
      seconds: seconds,
    });

    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      timer: seconds,
      isNegative: this.props.params.isNegative,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/updateUserTimer', data).then(async res => {
      if (res.success) {
      }
    });
  }

  submitTest = () => {
    const { questionsData } = this.state;
    this.setState({
      showFinishTestPopup: false,
    });
    //api to update status of quiz
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
      status: 'completed',
    };

    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/updateUserQuizStatus', data).then(
      async res => {
        if (res.success) {
        }
      },
    );
    const ansdata = {
      token: this.state.token,
      idname: this.state.idname,
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getrightAnswer', ansdata).then(
      resp_count => {
        if (resp_count.success) {
          const data = {
            token: this.state.token,
            idname: this.state.idname,
            mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
            score: resp_count.allrightanswercount.question_count,
            id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
          };
          FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/updateUserScore', data);
        } else {
          //console.log(resp_count.success + '------------failure');
        }
      },
    );
    const { id, testid, timer } = this.props.params;
    this.context.router.push({
      pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTION_FINISH)
        .replace(':id', id)
        .replace(':testid', testid)
        .replace(
          ':questiono',
          questionsData.length && questionsData[0] && questionsData[0].id ? questionsData[0].id : 1,
        )
        .replace(':timer', timer)
        .replace(':offset', 0),

      // pathname: `/cfa1_2024/cbtquestionsfinish/${this.props.params.id}/${
      //   questionsData.length && questionsData[0] && questionsData[0].id ? questionsData[0].id : 1
      // }/${this.props.params.timer}/${this.props.params.testid}/0`,
    });
  };

  flagQuestion = data => {
    const { flag } = this.state;
    let flaggedQuestions = flag.filter(flag => flag.question_id === data.id)[0];
    const flagdata = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: data.id,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    if (flaggedQuestions) {
      showSuccess('Question Unflagged');
    } else {
      showSuccess('Question Flagged');
    }
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/flagQuestion', flagdata).then(async res => {
      if (res) {
        this.getFlagQuestions();
      }
    });
  };

  getFlagQuestions = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    const data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getflaggedQuestions', data).then(
      async res => {
        if (res) {
          this.setState({ flag: res.data });
        }
      },
    );
  };

  changeFilter = (e, type) => {
    const { target } = e;
    const { checked } = target;
    const { filter } = this.state;
    if (checked) {
      let temp = [...filter];
      temp.push(type);
      this.setState({
        filter: temp,
      });
    } else {
      // to uncheck elements
      let prevArray = filter.filter(item => item !== type);
      this.setState({
        filter: prevArray,
      });
    }
  };

  finishTest = () => {
    const { flag, userStatsData, questionsData } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    if (flag && flag.length) {
      this.setState({
        showFlaggedPopup: true,
      });
    } else if (Object.keys(userChoice).length !== questionsData.length) {
      this.setState({
        showNonAttemptedPopup: true,
      });
    } else {
      this.setState({ showFinishTestPopup: true });
    }
  };

  componentWillUnmount() {
    clearInterval(this.timer);
  }

  stopTimer = () => {
    const { timerStart } = this.state;
    if (timerStart === 'true') {
      this.setState({
        timerStart: 'false',
      });
      this.context.router.push({
        pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTIONS)
          .replace(':id', this.props.params.id)
          .replace(':questiono', this.props.params.questiono)
          .replace(':timer', this.props.params.timer)
          .replace(':testid', this.props.params.testid)
          .replace(':offset', this.props.params.offset)
          .replace(':isNegative', this.props.params.isNegative)
          .replace(':timerStart', 'false'),
      });
      clearInterval(this.timer);
    } else {
      this.setState({
        timerStart: 'true',
      });
      this.context.router.push({
        pathname: nextAwareRoute(AppRoutes.CFA1_2024_CBT_QUESTIONS)
          .replace(':id', this.props.params.id)
          .replace(':questiono', this.props.params.questiono)
          .replace(':timer', this.props.params.timer)
          .replace(':testid', this.props.params.testid)
          .replace(':offset', this.props.params.offset)
          .replace(':isNegative', this.props.params.isNegative)
          .replace(':timerStart', 'true'),
      });
      this.timer = setInterval(this.countDown, 1000);
    }
  };

  addHighlightToText = () => {
    let text = this.getSelectionHtml();
    this.addHighlight(text);
  };

  deleteHighlightFromText = () => {
    let text = this.getSelectionHtml();

    const { highlights } = this.state;
    let getHighlightedTextData = highlights
      ? highlights.filter(item => {
        return item.text === text;
      })[0]
      : [];

    this.deleteHighlight(getHighlightedTextData.id);
  };

  getStrikedText = () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    let data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id) : null,
      question_id: this.props.params.questiono ? parseInt(this.props.params.questiono) : null,
      test_id: this.props.params.testid ? parseInt(this.props.params.testid) : null,
    };
    FD.callAPI(App_data.backend_api + '/cfaCBTMockExams/getStrikedText', data).then(async res => {
      if (res && res.questions) {
        this.setState({
          strikeThroughArr: JSON.parse(res.questions.choiceArray),
        });
      } else {
        this.setState({
          strikeThroughArr: [],
        });
      }
    });
  };

  getSelectionHtml = () => {
    var html = '';
    if (typeof window.getSelection != 'undefined') {
      var sel = window.getSelection();
      //console.log('heyyyyyyyyyyyyyyyy', sel);
      if (sel.rangeCount) {
        var container = document.createElement('div');
        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }
        html = container.innerHTML;
      }
    } else if (typeof document.selection != 'undefined') {
      if (document.selection.type == 'Text') {
        html = document.selection.createRange().htmlText;
      }
    }
    return html;
  };

  // for IOS
  onTouchStart = (e, choice) => {
    e.preventDefault();
    // console.log(' window.navigator', window.navigator);
    const data = this.getMobileOperatingSystem();
    //console.log('datadata', data);
    if (data === 'Android') {
      return;
    } else {
      this.longPressCountdown = setTimeout(() => {
        //console.log('heyyyyyy in longpresssss', this.longPressCountdown);
        this.addStrikeThrough(choice);
      }, longPressDuration);
    }
  };

  onTouchMove = e => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchCancel = e => {
    clearTimeout(this.longPressCountdown);
  };

  onTouchEnd = e => {
    clearTimeout(this.longPressCountdown);
  };

  render() {
    const {
      isLoading,
      questionsData,
      showFinishTestPopup,
      userStatsData,
      mockName,
      flag,
      showSectionReview,
      showNonAttemptedPopup,
      showFlaggedPopup,
      filter,
      selectedQuestionData,
      isDataLoading,
      seconds,
      timerStart,
      highlights,
      strikeThroughArr,
    } = this.state;
    let userChoice =
      userStatsData && userStatsData.questions ? JSON.parse(userStatsData.questions) : '';
    const formatTimeF = SecondsToHHMMSS(seconds);
    let flaggedQuestion = flag.filter(flag => flag.question_id === selectedQuestionData.id)[0];
    const sliderSettings = questionsettings(
      this.props.params.offset ? parseInt(this.props.params.offset) : 1,
    );
    let content = selectedQuestionData.question;
    if (highlights) {
      highlights.forEach(element => {
        content = highlightString(content, element.text);
      });
    }

    let text = this.getSelectionHtml();
    let highlighted = `<b style="background-color: yellow" title="highlighted">${text}</b>`;
    let getHighlightedText = content ? content.indexOf(highlighted) : null;
    //console.log('text isss', text);
    return (
      <div>
        <div className='animated fadeIn'>
          <div className='margin_bottom_20 ques-title-wrapper'>
            <h1 className='section_head'>{mockName}</h1>
            <div className='finish-btn-wrapper'>
              <Button onClick={() => this.finishTest()} className='pointer_class btn-primary'>
                {language.LC().Finish_Test}
              </Button>
            </div>
          </div>
          {isLoading ? (
            <Loader />
          ) : questionsData && questionsData.length ? (
            <div>
              <div className='row'>
                <div className='qus-tab-wrapper'>
                  <Slider
                    {...sliderSettings}
                    ref={slider => {
                      this.slider = slider;
                    }}
                  >
                    {questionsData.map((item, index) => {
                      let flaggedQuestions = flag.filter(flag => flag.question_id === item.id)[0];
                      return (
                        <div className='slide-button' key={index}>
                          <Button
                            onClick={() => this.changeQuestion(item.id, index)}
                            className={`
                        ${index === parseInt(this.props.params.offset) ? 'active' : ''}
                        ${userChoice[item.id] ? 'completed-qus' : ''}
                        ${flaggedQuestions ? 'flag-add' : ''}
                        `}
                          >
                            {index + 1}
                            {flaggedQuestions ? (
                              <img
                                width='70'
                                src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                                alt='Question'
                              />
                            ) : (
                              ''
                            )}
                          </Button>
                        </div>
                      );
                    })}
                  </Slider>
                </div>
                <div className='ques-detail-wrapper col-md-12 question-wrapper'>
                  {isDataLoading ? (
                    <Loader />
                  ) : (
                    <div className='card'>
                      <div className='card-block'>
                        <div className='row'>
                          <div className='col-sm-8 col-lg-9'>
                            {/* heder data */}
                            {/* <div className='card-header d-flex justify-content-between qus-header finish-question-wrapper'> */}
                            {selectedQuestionData && selectedQuestionData.question ? (
                              <div className='qus-wrapper ques-bold-remove d-block all-ques'>
                                <div>
                                  <img
                                    src={
                                      App_data.frontend_url +
                                      '/img/question_bank/question_icon_blue.svg'
                                    }
                                    className='margin_right_20'
                                    alt=''
                                    width='30'
                                  />
                                  Q.{parseInt(this.props.params.offset) + 1}
                                </div>
                                <div
                                  style={{
                                    position: 'relative',
                                    marginTop: '8px',
                                    maxWidth: '100%',
                                  }}
                                >
                                  <div data-selectable>
                                  {renderHTMLContent(content, "div", "qus-title d-inline-block w-100")}
                                  </div>
                                  <SelectionPopover
                                    showPopover={this.state.showPopover}
                                    onSelect={() => {
                                      this.setState({ showPopover: true });
                                    }}
                                    onDeselect={() => {
                                      this.setState({ showPopover: false });
                                    }}
                                  >
                                    {getHighlightedText === -1 ? (
                                      <div className='highlight-popover tooltip_wrap'>
                                        <img
                                          src={App_data.frontend_url + '/img/high-edit-ico.svg'}
                                          alt='523'
                                          width='30'
                                          onClick={() => this.addHighlightToText()}
                                        />
                                        <div className='tootip_box'>
                                          {language.LC().Click_me_to_highlight}
                                        </div>
                                      </div>
                                    ) : (
                                      <div className='highlight-popover tooltip_wrap'>
                                        <img
                                          src={App_data.frontend_url + '/img/icon_select_text.png'}
                                          alt='523'
                                          width='30'
                                          onClick={() => this.deleteHighlightFromText()}
                                        />
                                        <div className='tootip_box'>
                                          {language.LC().Click_me_to_unhighlight}
                                        </div>
                                      </div>
                                    )}
                                  </SelectionPopover>
                                </div>
                              </div>
                            ) : null}
                            {/* </div> */}
                            <div className='row'>
                              {optionsArr.map((item, index) => {
                                return (
                                  <div
                                    className='col-sm-12'
                                    id={item}
                                    key={index}
                                    onClick={e => {
                                      this.clickOption(
                                        item,
                                        selectedQuestionData && selectedQuestionData.id
                                          ? selectedQuestionData.id
                                          : null,
                                        selectedQuestionData,
                                        e,
                                      );
                                    }}
                                    onContextMenu={e => {
                                      this.clickOption(
                                        item,
                                        selectedQuestionData && selectedQuestionData.id
                                          ? selectedQuestionData.id
                                          : null,
                                        selectedQuestionData,
                                        e,
                                      );
                                    }}
                                    onTouchStart={e => {
                                      this.onTouchStart(e, item);
                                    }}
                                    onTouchCancel={e => {
                                      this.onTouchCancel(e);
                                    }}
                                    onTouchEnd={e => {
                                      this.onTouchEnd(e);
                                    }}
                                    onTouchMove={e => {
                                      this.onTouchMove(e);
                                    }}
                                  >
                                    <div
                                      className={`answer_box ${userChoice[selectedQuestionData.id] === item
                                        ? `border-yellow`
                                        : 'border-black'
                                        }`}
                                    >
                                      <div
                                        className={`answer_count highlight_choice no-selection ${item === 'choice_a'
                                          ? strikeThroughArr.includes('choice_a')
                                            ? 'strikethrough'
                                            : ''
                                          : item === 'choice_b'
                                            ? strikeThroughArr.includes('choice_b')
                                              ? 'strikethrough'
                                              : ''
                                            : item === 'choice_c'
                                              ? strikeThroughArr.includes('choice_c')
                                                ? 'strikethrough'
                                                : ''
                                              : ''
                                          }`}
                                      >
                                        {item === 'choice_a'
                                          ? language.LC().A
                                          : item === 'choice_b'
                                            ? language.LC().B
                                            : language.LC().C}
                                      </div>
                                      <p
                                        className={`ans_box_text tooltip_wrap ${item === 'choice_a'
                                          ? strikeThroughArr.includes('choice_a')
                                            ? 'strikethrough'
                                            : ''
                                          : item === 'choice_b'
                                            ? strikeThroughArr.includes('choice_b')
                                              ? 'strikethrough'
                                              : ''
                                            : item === 'choice_c'
                                              ? strikeThroughArr.includes('choice_c')
                                                ? 'strikethrough'
                                                : ''
                                              : ''
                                          }`}
                                      >
                                        {selectedQuestionData && selectedQuestionData[item] ? (
                                        renderHTMLContent(selectedQuestionData[item], "span", "no-selection", { contentEditable: "false" })
                                        ) : null}
                                      </p>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                          <div className='col-sm-4 col-lg-3'>
                            <div className='timer_outer mb-15'>
                              <div>
                                <h2 className='time-left-heading'>{language.LC().TIME_LEFT}</h2>
                                <span
                                  className={`timer_box ${this.props.params.isNegative === 'false' ? 'blink' : null
                                    }`}
                                >
                                  {this.props.params.isNegative === 'false'
                                    ? `- ${formatTimeF}`
                                    : formatTimeF}
                                </span>
                              </div>
                            </div>
                            <button
                              type='button'
                              aria-label={timerStart === 'true' ? 'Pause timer and take a break' : 'Resume timer'}
                              className={`tooltip_wrap mb-2 hover-pad-same
                                ${timerStart === 'true'
                                  ? 'icon-control-pause pause_btn'
                                  : 'pause_btn icon-control-play'
                                }`}
                              onClick={() => this.stopTimer()}
                            >
                              <div className='tootip_box' aria-hidden='true'>{language.LC().Save_and_Take_Break}</div>
                            </button>
                          </div>
                          <div className='col-sm-3 d-sm-flex align-items-end text-center text-sm-left mt-1'>
                            <button
                              type='button'
                              aria-label={language.LC().SECTION_REVIEW}
                              className='menu-btn tooltip-hover-questions'
                              onClick={() => {
                                this.setState({
                                  showSectionReview: true,
                                });
                              }}
                            >
                              <img
                                width='30px'
                                src={App_data.frontend_url + '/img/questions/icon_menu.png'}
                                className='my-1'
                                alt=''
                              />
                              <div className='tootip_box' aria-hidden='true'>{language.LC().SECTION_REVIEW}</div>
                            </button>
                          </div>
                          <div className='col-sm-9 mt-1'>
                            <div className='text-center text-sm-right btm-btn-wrapper quiz-submit-block'>
                              <span className='up tooltip-hover-questions quiz-flag'>
                                {flaggedQuestion ? (
                                  <div className='tootip_box'>
                                    {language.LC().UNFLAG_THIS_QUESTION}
                                  </div>
                                ) : (
                                  <div className='tootip_box'>
                                    {language.LC().FLAG_THIS_QUESTION}
                                  </div>
                                )}
                                <i
                                  onClick={() => this.flagQuestion(selectedQuestionData)}
                                  className={
                                    flaggedQuestion
                                      ? `fa fa-flag mark-action-btn`
                                      : `fa fa-flag-o mark-action-btn`
                                  }
                                >
                                  {' '}
                                </i>
                              </span>

                              <Button
                                onClick={() => this.getPrevious(this.props.params.offset)}
                                className='pointer_class btn-primary'
                                disabled={parseInt(this.props.params.offset) === 0}
                              >
                                <i className='fa fa-angle-left' /> {language.LC().BACK}
                              </Button>
                              <Button
                                onClick={() => this.getNext(this.props.params.offset)}
                                className='pointer_class btn-primary'
                                disabled={
                                  parseInt(this.props.params.offset) === questionsData.length - 1
                                }
                              >
                                {language.LC().NEXT} <i className='fa fa-angle-right' />
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className='no-qus-found'>
              <img width='105px' src={App_data.frontend_url + '/img/questions/problem.png'} alt='' />
              <h3>{language.LC().NO_QUESTION_FOUND}</h3>
              <p> {language.LC().NO_QUESTION_FOR_THIS_EXAM}</p>
            </div>
          )}
        </div>
        {/* =========For Side Bar S============ */}
        <div className={`sidebar-review-wrapper ${showSectionReview ? 'active' : ''}`}>
          <div className='header-review'>
            <h2>{language.LC().SECTION_REVIEW}</h2>
            <button
              type='button'
              aria-label='Close section review'
              className='section-review-close'
              onClick={() => {
                this.setState({
                  showSectionReview: false,
                });
              }}
            >
              <img width='30px' src={App_data.frontend_url + '/img/questions/icon_close.png'} alt='' />
            </button>
          </div>
          <div className='body-review'>
            <h3>{language.LC().FILTER_BY}:</h3>
            <div className='filt-list-wrapper'>
              <button
                className='btn btn-primary small-btn'
                onClick={() => {
                  this.setState({
                    filter: [],
                  });
                }}
              >
                {language.LC().CLEAR}
              </button>
              <ul>
                {filterObj.map((item, index) => {
                  return (
                    <li className='plan_wrapper remove-plan' key={index}>
                      <label className='check_container'>
                        <input
                          type='checkbox'
                          value={item}
                          id={item}
                          checked={filter.indexOf(item) > -1 ? true : false}
                          onChange={e => this.changeFilter(e, item)}
                        />
                        <span className='checkmark' /> {item}
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className='qus-tab-wrapper'>
              {questionsData.map((item, index) => {
                let flaggedQuestions = flag.filter(flag => flag.question_id === item.id)[0];
                return (
                  <div key={index}>
                    {filter.includes('Attempted') &&
                      filter.includes('Unattempted') &&
                      filter.includes('Flagged') ? (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''} ${flaggedQuestions ? 'flag-add' : ''
                          }`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                        {flaggedQuestions ? (
                          <img
                            width='70'
                            src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                            alt='Question'
                          />
                        ) : (
                          ''
                        )}
                      </Button>
                    ) : filter.includes('Attempted') && filter.includes('Unattempted') ? (
                      <Button
                        className={`${userChoice[item.id] ? 'completed-qus' : ''}`}
                        onClick={() => {
                          this.setState({
                            showSectionReview: false,
                          });
                          this.changeQuestion(item.id, index);
                        }}
                      >
                        {index + 1}
                      </Button>
                    ) : filter.includes('Unattempted') && filter.includes('Flagged') ? (
                      !userChoice[item.id] && flaggedQuestions ? (
                        <Button
                          className={` ${flaggedQuestions ? 'flag-add' : ''}`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                          {flaggedQuestions ? (
                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      ) : (
                        ''
                      )
                    ) : ///
                      filter.includes('Attempted') && filter.includes('Flagged') ? (
                        userChoice[item.id] && flaggedQuestions ? (
                          <Button
                            className={`${userChoice[item.id] ? 'completed-qus' : ''} ${flaggedQuestions ? 'flag-add' : ''
                              }`}
                            onClick={() => {
                              this.setState({
                                showSectionReview: false,
                              });
                              this.changeQuestion(item.id, index);
                            }}
                          >
                            {index + 1}
                            {flaggedQuestions ? (
                              <img
                                width='70'
                                src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                                alt='Question'
                              />
                            ) : (
                              ''
                            )}
                          </Button>
                        ) : (
                          ''
                        )
                      ) : filter.includes('Attempted') ? (
                        userChoice[item.id] ? (
                          <Button
                            className={'completed-qus'}
                            onClick={() => {
                              this.setState({
                                showSectionReview: false,
                              });
                              this.changeQuestion(item.id, index);
                            }}
                          >
                            {index + 1}
                          </Button>
                        ) : (
                          ''
                        )
                      ) : filter.includes('Unattempted') ? (
                        !userChoice[item.id] ? (
                          <Button
                            onClick={() => {
                              this.setState({
                                showSectionReview: false,
                              });
                              this.changeQuestion(item.id, index);
                            }}
                          >
                            {index + 1}
                          </Button>
                        ) : (
                          ''
                        )
                      ) : filter.includes('Flagged') ? (
                        flaggedQuestions ? (
                          <Button
                            className={`${userChoice[item.id] ? 'flag-add completed-qus' : 'flag-add '
                              }`}
                            onClick={() => {
                              this.setState({
                                showSectionReview: false,
                              });
                              this.changeQuestion(item.id, index);
                            }}
                          >
                            {index + 1}

                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          </Button>
                        ) : (
                          ''
                        )
                      ) : (
                        <Button
                          className={`${userChoice[item.id] ? 'completed-qus' : ''} ${flaggedQuestions ? 'flag-add' : ''
                            }`}
                          onClick={() => {
                            this.setState({
                              showSectionReview: false,
                            });
                            this.changeQuestion(item.id, index);
                          }}
                        >
                          {index + 1}
                          {flaggedQuestions ? (
                            <img
                              width='70'
                              src={App_data.frontend_url + '/img/questions/icon_flag_white.png'}
                              alt='Question'
                            />
                          ) : (
                            ''
                          )}
                        </Button>
                      )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* =========For Side Bar E============ */}
        <CBTFinishTest
          showFinishTestPopup={showFinishTestPopup}
          submitTest={() => this.submitTest()}
          handleClose={() => this.setState({ showFinishTestPopup: false })}
        />
        <CBTNonAttempted
          showFinishTestPopup={showNonAttemptedPopup}
          submitTest={() =>
            this.setState({
              showFinishTestPopup: true,
              showNonAttemptedPopup: false,
            })
          }
          handleClose={() => this.setState({ showNonAttemptedPopup: false })}
        />
        <CBTFlagged
          showFinishTestPopup={showFlaggedPopup}
          submitTest={() =>
            this.setState({
              showFlaggedPopup: false,
              showFinishTestPopup: true,
            })
          }
          handleClose={() => this.setState({ showFlaggedPopup: false })}
        />
      </div>
    );
  }
}

export default CFAQuestions;



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/CFA1CBT/Questions/index.js